import { WillMyCreditsTransferContext } from '@/store/wmct';
import { client } from '@/models/services/collegetransfer';
import courseValidator from '@/models/validation/CourseEntryValidator';
import assessmentValidator from '@/models/validation/AssessmentEntryValidator';
import LearningEntry from '@/models/LearningEntry';

function isCourseEntry(learning: LearningEntry) {
	// assumption: learning instanceOf CourseEntry will not work if learning is an observed object
	const check: any = learning;

	return check.grade !== undefined;
}

function isAssessmentEntry(learning: LearningEntry) {
	// assumption: learning instanceOf CourseEntry will not work if learning is an observed object
	const check: any = learning;

	return check.score !== undefined;
}

function getValidator(learning: LearningEntry): any {
	if (isCourseEntry(learning)) {
		return courseValidator;
	}

	if (isAssessmentEntry(learning)) {
		return assessmentValidator;
	}

	throw new Error(`Cannot get validator for entity`);
}

export default {
	async checkinWithApi(context: WillMyCreditsTransferContext): Promise<void> {
		if (!context.state.api.data) {
			try {
				context.commit('UPDATE_API_STATUS_BEGIN');
				const result = await client.checkIn();
				context.commit('UPDATE_API_STATUS_END', { result });
			} catch (error) {
				context.commit('UPDATE_API_STATUS_END', { result: null, error });
			}
		}
	},

	async editLearning(context: WillMyCreditsTransferContext, { learning }: { learning: LearningEntry }) {
		context.commit('EDIT_LEARNING', { editable: learning });
	},

	async cancelEditLearning(context: WillMyCreditsTransferContext, { learning }: { learning: LearningEntry }) {
		if (learning.id) {
			context.commit('EDIT_LEARNING', { editable: learning });
		} else {
			if (isCourseEntry(learning)) {
				context.commit('REMOVE_COURSE', { course: learning });
			} else if (isAssessmentEntry(learning)) {
				context.commit('REMOVE_ASSESSMENT', { assessment: learning });
			}
		}
	},

	async removeLearning(context: WillMyCreditsTransferContext, { learning }: { learning: LearningEntry }) {
		context.commit('BEGIN_LEARNING_PERISTING', { learning, validator: getValidator(learning) });

		// Artificial delay
		await new Promise<void>((resolve, _) => setTimeout(() => resolve(), 1000));

		if (isCourseEntry(learning)) {
			context.commit('REMOVE_COURSE', { course: learning });
		} else if (isAssessmentEntry(learning)) {
			context.commit('REMOVE_ASSESSMENT', { assessment: learning });
		}

		await context.dispatch('runEquivalencyMap');
	},

	async persistLearning(context: WillMyCreditsTransferContext, { learning }: { learning: LearningEntry }) {
		context.commit('BEGIN_LEARNING_PERISTING', { learning, validator: getValidator(learning) });

		if (!learning.isValidating) {
			// Artificial delay
			await new Promise<void>((resolve, _) => setTimeout(() => resolve(), 1000));
			const id = learning.id || Math.floor(Math.random() * (10000000 - 1000000 + 1) + 1000000);
			const persistResult = { entity: id };

			context.commit('END_LEARNING_PERSISTING', { learning, persistResult });

			await context.dispatch('runEquivalencyMap');
		}
	},

	async runEquivalencyMap(context: WillMyCreditsTransferContext) {
		context.commit('BEGIN_EQUIV_MAP_UPDATE');

		try {
			const wmctResponse = await client.willMyCreditsTransfer(context.getters.equivalencyRequestPayload);
			context.commit('END_EQUIV_MAP_UPDATE', { wmctResponse });
		} catch (err) {
			context.commit('END_EQUIV_MAP_UPDATE', { wmctResponse: null, err});
		}
	},

	reset(context: WillMyCreditsTransferContext) {
		context.commit('RESET');
	},

	updateSeenEquivalencies(context: WillMyCreditsTransferContext) {
		const equivCount = context.getters.getAllEquivalencyCount;

		context.commit('UPDATE_SEEN_EQUIVS', equivCount);
	},
};
